import { useState } from "react";
import { IoClose } from "react-icons/io5";
import blinkscribelogo from "../../../assets/blinkscribe 4.svg";
import axios from "axios";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";

const RaiseTicket = ({ setModal, ismodal }) => {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [errors, setErrors] = useState({});
  const [statusMessage, setStatusMessage] = useState("");
  const [statusType, setStatusType] = useState(""); // success or error
  const [loading, setLoading] = useState(false);

  if (!ismodal) return null;

  const handleSubmit = async () => {
    const newErrors = {};
    setStatusMessage("");
    setStatusType("");

    if (!email.trim()) {
      newErrors.email = "Email is required.";
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      newErrors.email = "Invalid email";
    }

    if (!message.trim()) {
      newErrors.message = "Message is required.";
    }

    setErrors(newErrors);

    if (Object.keys(newErrors).length > 0) return;

    const currentTime = new Date().toLocaleString("en-IN", {
      timeZone: "Asia/Kolkata",
      weekday: "short",
      year: "numeric",
      month: "short",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });

    const htmlContent = `
      <div style="font-family: Arial, sans-serif; font-size: 14px; color: #333; line-height: 1.6;">
        <p>Dear Support Team,</p>
        <p>A user has submitted a message via the <strong>Help & Support</strong> form.</p>
        <hr style="border: none; border-top: 1px solid #ccc;" />
        <h3 style="color: #156CFE; margin-top: 20px;">Message:</h3>
        <div style="background-color: #f4f8ff; padding: 12px; border-left: 4px solid #156CFE; border-radius: 4px;">
          ${message.replace(/\n/g, "<br/>")}
        </div>
        <h4 style="margin-top: 25px;">User Details</h4>
        <ul style="list-style-type: none; padding-left: 0;">
          <li><strong>Email:</strong> ${email}</li>
          <li><strong>Submitted At:</strong> ${currentTime}</li>
        </ul>
        <p style="margin-top: 25px;">Please respond as soon as possible.</p>
        <p>Best regards,<br/>System Notification - Help Desk</p>
      </div>
    `;

    setLoading(true);
    try {
   const formData = new FormData();
formData.append("to", "admin@brainymed.com");
formData.append("subject", `New support request from ${email}`);
formData.append("message", htmlContent);

await axios.post("https://api.prd.brainymed.com/utility/send-email", formData, {
  headers: {
    "Content-Type": "multipart/form-data",
  },
});


      setStatusMessage("Your message was sent successfully.");
      setStatusType("success");
      setEmail("");
      setMessage("");
    } catch (error) {
      console.error("Email send error:", error);
      setStatusMessage("Failed to send the message. Please try again later.");
      setStatusType("error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg shadow-lg w-full max-w-5xl flex overflow-hidden relative">
        {/* Close Button */}
        <button
          onClick={() => {
            setMessage("");
            setEmail("");
            setErrors({});
            setStatusMessage("");
            setStatusType("");
            setModal(false);
          }}
          className="absolute top-3 right-3 text-gray-500 hover:text-black text-xl"
        >
          <IoClose />
        </button>

        {/* Left Section */}
        <div className="w-full sm:w-[60%] p-10 text-start">
          <h3 className="text-lg font-semibold text-[#121212]">Get in Touch</h3>
          <h1 className="text-3xl font-bold mt-1 mb-2 text-[#0D141C]">Let's Chat, Reach Out to Us</h1>
          <p className="text-sm text-[#000] mb-6">Have questions? We're here to help. Send us a message.</p>

          <label className="block mb-2 text-sm font-normal text-gray-600">Email</label>
          <div className="relative mb-1">
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full border-b border-[#D1D5DC] py-2 pl-3 pr-10 bg-transparent text-gray-800 focus:outline-none transition duration-300"
            />
          </div>
          {errors.email && <p className="text-red-500 text-sm mb-2">{errors.email}</p>}

          <label className="block mb-2 text-sm font-normal text-gray-600 mt-4">Message</label>
          <textarea
            rows="6"
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            placeholder="Let us know how we can help you.."
            className="w-full border-b border-[#D1D5DC] bg-transparent text-gray-800 px-3 py-2 text-sm resize-none focus:outline-none"
          />
          {errors.message && <p className="text-red-500 text-sm mb-2">{errors.message}</p>}

          {statusMessage && (
            <p className={`text-sm mt-2 ${statusType === "success" ? "text-green-600" : "text-red-600"}`}>
              {statusMessage}
            </p>
          )}

          <button
            onClick={handleSubmit}
            className="bg-[#156CFE] hover:bg-blue-700 text-white px-6 sm:px-10 py-3 mt-4 rounded text-sm font-medium"
          >
            Send Message
          </button>
        </div>

        {/* Right Section */}
        <div
          className="w-[40%] p-10 hidden sm:flex justify-start text-start"
          style={{
            background: "linear-gradient(to bottom, white 0%, white 30%, #A2C6FDCC 100%)",
          }}
        >
          <div className="w-fit">
            <div className="w-full flex justify-end">
              <img src={blinkscribelogo} alt="blinkScribe Logo" className="w-[200px] mb-6" />
            </div>

            <p className="mb-1">You can also reach us at:</p>
            <div className="mt-4 flex gap-3 mb-12 flex-col">
              <p className="text-sm text-[#1E2939]">admin@brainymed.com</p>
              <p className="text-sm text-[#1E2939]">(682) 344 0264</p>
            </div>

            {/* <p className="text-sm text-[#0D141C]">For more information, visit our FAQ page.</p>
            <a href="#" className="text-blue-600 text-sm">
              Go to FAQ
            </a> */}
          </div>
        </div>
      </div>

      {/* Loading Spinner */}
      <Backdrop sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }} open={loading}>
        <CircularProgress color="inherit" size={40} />
      </Backdrop>
    </div>
  );
};

export default RaiseTicket;
